import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Colors } from '@core/constants/common';
import { ColorEnum } from '@core/enum/common';
import { OverlayModule } from 'primeng/overlay';

@Component({
  selector: 'app-color-picker',
  standalone: true,
  imports: [CommonModule, OverlayModule],
  templateUrl: './color-picker.component.html',
  styleUrl: './color-picker.component.scss'
})
export class ColorPickerComponent {
  @Input() value = '';

  @Output() valueChange = new EventEmitter<string>();

  readonly Colors = Colors;
  readonly ColorEnum = ColorEnum;

  visible: boolean = false;

  get color() {
    return Colors.find(item => item.primaryColor === this.value);
  }

  toggle(event?: MouseEvent) {
    event?.stopPropagation();
    this.visible = !this.visible;
  }

  onSelectColor(value: string, event?: MouseEvent) {
    event?.stopPropagation();
    this.value = value;
    this.valueChange.emit(this.value);

    setTimeout(() => {
      this.visible = false;
    });
  }
}
